import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
const apiUrl = process.env.REACT_APP_API_URL;

const EditPOModal = ({ po, onClose, onSave }) => {
  const [vendor, setVendor] = useState(po.vendor || '');
  const [expected_date, setExpectedDate] = useState(po.expected_date || '');
  const [status, setStatus] = useState(po.status || 'Open');
  const [notes, setNotes] = useState(po.notes || '');
  
  const [jobNumber, setJobNumber] = useState(po.job_number || '');
  const [jobNumberValid, setJobNumberValid] = useState(true); // default true if empty
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!jobNumberValid) {
      toast.error('Invalid job number. Please enter a valid job number.', { position: 'top-center' });
      return;
    }
    onSave({ ...po, job_number: jobNumber, vendor, expected_date, status, notes });
  };

  const handleJobNumberChange = (e) => {
    const value = e.target.value.trim();
    setJobNumber(value);

    // If empty, always valid
    if (!value) {
      setJobNumberValid(true);
      return;
    }

    // Otherwise, debounce API check
    setJobNumberValid(false);
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    if (value.length >= 3) {
      const timeout = setTimeout(async () => {
        try {
          const response = await axios.get(`${apiUrl}/inventory_crud.php`, {
            params: { checkJobNumberExists: value },
          });
          setJobNumberValid(response.data.exists === true);
        } catch {
          setJobNumberValid(false);
        }
      }, 500);
      setDebounceTimeout(timeout);
    } else {
      setJobNumberValid(false);
    }
  };


  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
        <h2 className="text-lg font-bold mb-4">
          {po?.po_number ? `Edit Purchase Order #${po.po_number}` : 'New Purchase Order'}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold">Vendor</label>
            <input
              type="text"
              value={vendor}
              onChange={e => setVendor(e.target.value)}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold">Job Number</label>
            <input
              type="text"
              value={jobNumber}
              onChange={handleJobNumberChange}
              className={`w-full border rounded px-3 py-2 ${!jobNumberValid && jobNumber ? 'border-red-500' : ''}`}
            />
            {!jobNumberValid && jobNumber && (
              <div className="text-red-600 text-xs mt-1">This job number does not exist.</div>
            )}
          </div>

          <div>
            <label className="block text-sm font-semibold">Expected Date</label>
            <input
              type="date"
              value={expected_date}
              onChange={e => setExpectedDate(e.target.value)}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold">Status</label>
            <select
              value={status}
              onChange={e => setStatus(e.target.value)}
              className="w-full border rounded px-3 py-2"
            >
              <option value="Open">Open</option>
              <option value="Ordered">Ordered</option>
              <option value="Received">Received</option>
              {/* <option value="Closed">Closed</option>
              <option value="Cancelled">Cancelled</option> */}
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold">Notes</label>
            <textarea
              value={notes}
              onChange={e => setNotes(e.target.value)}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-200 text-black px-4 py-2 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!jobNumberValid}
              className={`bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 ${!jobNumberValid ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPOModal;
